import React from "react";
import BrandStyleSheet from "./BrandStyleSheet";

const LoadingPage = (props) => {
  window.scrollTo(0, 0);

  return (
    <div
      id="loading"
      className="flex flex-col w-full h-full justify-end bg-cover bg-no-repeat bg-center relative z-20"
      style={{
        backgroundColor: props.backgroundColor,
        backgroundImage: `url(${props.backgroundImage})`,
      }}>
      <BrandStyleSheet brandStyleSheet={props.brandStyleSheet} />
      <div
        className=" h-full flex flex-col w-full justify-end"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.0), rgba(0,0,0,1) 100%)",
          maxHeight: "600px",
          minHeight: "500px",
        }}>
        <div className="text-white w-full py-20">
          <div className="max-w-xl mx-auto">
            <h2
              className="type-title xxLarge mb-5 uppercase px-5"
              style={{ color: "#ffffff", lineHeight: "inherit" }}>
              {props.title}
            </h2>
            <p
              className="type-regular normal px-5"
              style={{ color: "#ffffff" }}>
              {props.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
